// extracted by mini-css-extract-plugin
module.exports = {"chevron":"menu_chevron___HyYO","chevronUp":"menu_chevronUp__0ezv7","fadein":"menu_fadein__nKi6y","loading":"menu_loading__pBvI3"};